import {css} from '@emotion/core';
import {
	ICARE_WHITE,
	ICARE_BLUE,
	ICARE_PURPLE,
	ICARE_MAGENTA,
	ICARE_RED,
	ICARE_TEAL,
	ICARE_YELLOW,
	ICARE_ORANGE,
	ICARE_LIME_GREEN,
} from './colors';

export function theme(themeColor, alt = false) {
	if (themeColor === 'blue') {
		return css`
			background: ${ICARE_BLUE};
		`;
	} else if (themeColor === 'magenta') {
		return css`
			background: ${ICARE_MAGENTA};
			${alt
				? css`
						color: ${ICARE_WHITE};
				  `
				: css``}
		`;
	} else if (themeColor === 'purple') {
		return css`
			color: ${ICARE_WHITE};
			background: ${ICARE_PURPLE};
		`;
	} else if (themeColor === 'red') {
		return css`
			background: ${ICARE_RED};
			${alt
				? css`
						color: ${ICARE_WHITE};
				  `
				: css``}
		`;
	} else if (themeColor === 'teal') {
		return css`
			background: ${ICARE_TEAL};
			${alt
				? css`
						color: ${ICARE_WHITE};
				  `
				: css``}
		`;
	} else if (themeColor === 'yellow') {
		return css`
			background: ${ICARE_YELLOW};
		`;
	} else if (themeColor === 'orange') {
		return css`
			background: ${ICARE_ORANGE};
		`;
	} else if (themeColor === 'lime-green') {
		return css`
			background: ${ICARE_LIME_GREEN};
		`;
	}
}

export function pulseBar(colour1, colour2, stop) {
	return css`
		background-image: linear-gradient(to right, ${colour1} ${stop}, ${colour2} ${stop});
	`;
}

export default theme;
